import { render, staticRenderFns } from "./AtomLottieAnimation.vue?vue&type=template&id=6b0d824a&"
import script from "./AtomLottieAnimation.vue?vue&type=script&lang=js&"
export * from "./AtomLottieAnimation.vue?vue&type=script&lang=js&"
import style0 from "./AtomLottieAnimation.vue?vue&type=style&index=0&id=6b0d824a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports